export const COPYRIGHT_LICENSE = 'Creative Commons licenses give everyone from individual creators to large institutions a standardized way to grant the public permission to use their creative work under copyright law. From the reuser’s perspective, the presence of a Creative Commons license on a copyrighted work answers the question, “What can I do with this work?”' as const;

export const COPY_RIGHTS = {
  CC0: {
    name: 'Public Domain Dedication (CC0)',
    shortname: 'CC0',
    description:
      'CC0 (aka CC Zero) is a public dedication tool, which allows creators to give up their copyright and put their works into the worldwide public domain. CC0 allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, with no conditions.',
  },
  CC_BY: {
    name: 'Attribution (CC BY)',
    shortname: 'CC BY',
    description:
      'This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, so long as attribution is given to the creator. The license allows for commercial use.',
  },
  CC_BY_SA: {
    name: 'Attribution-ShareAlike (CC BY-SA)',
    shortname: 'CC BY-SA',
    description:
      'This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format, so long as attribution is given to the creator. The license allows for commercial use. If you remix, adapt, or build upon the material, you must license the modified material under identical terms.',
  },
  CC_BY_ND: {
    name: 'Attribution-NoDerivs (CC BY-ND)',
    shortname: 'CC BY-ND',
    description:
      'This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format for noncommercial purposes only, and only so long as attribution is given to the creator.',
  },
  CC_BY_NC: {
    name: 'Attribution-NonCommercial (CC BY-NC)',
    shortname: 'CC BY-NC',
    description:
      'This license allows reusers to distribute, remix, adapt, and build upon the material in any medium or format for noncommercial purposes only, and only so long as attribution is given to the creator. If you remix, adapt, or build upon the material, you must license the modified material under identical terms.',
  },
  CC_BY_NC_SA: {
    name: 'Attribution-NonCommercial-ShareAlike (CC BY-NC-SA)',
    shortname: 'CC BY-NC-SA',
    description:
      'This license allows reusers to copy and distribute the material in any medium or format in unadapted form only, and only so long as attribution is given to the creator. The license allows for commercial use.',
  },
  CC_BY_NC_ND: {
    name: 'Attribution-NonCommercial-NoDerivs (CC BY-NC-ND)',
    shortname: 'CC BY-NC-ND',
    description:
      'This license allows reusers to copy and distribute the material in any medium or format in unadapted form only, for noncommercial purposes only, and only so long as attribution is given to the creator.',
  },
  ALL_RIGHTS_RESERVED: {
    name: 'All Rights Reserved',
    shortname: 'All Rights Reserved',
    description: 'Others cannot use your work without explicit permission.',
  },
} as const;
